import React, { forwardRef } from 'react';
import { Button } from '@warp-ds/react';
import type { variant } from './types';
import { IconFavorite16 } from './Icons';
import { i18n } from '@lingui/core';

type HeartButtonProps = {
    className?: string;
    variant: variant;
    onClick: () => void;
    toggled: boolean;
    numFavs: number;
};

const HeartButton = forwardRef(
    (props: HeartButtonProps, forwardRef: React.Ref<HTMLButtonElement>) => {
        const {
            className: externalClassname,
            onClick,
            toggled,
            variant,
            numFavs,
        } = props;

        let buttonProps = {};
        let iconProps = {};

        switch (variant) {
            case 'heart':
                buttonProps = { pill: true };
                break;
            case 'heart-blue':
                buttonProps = { pill: true };
                iconProps = { stroke: 'var(--w-s-color-icon-primary)' };
                break;
            case 'heart-on-image':
                buttonProps = { pill: true };
                iconProps = {
                    stroke: 'var(--w-s-color-icon-inverted)',
                    fill: 'var(--w-s-color-icon-subtle)',
                };
                break;
            case 'button':
                buttonProps = { utility: true, quiet: true };
                break;
        }

        return (
            <Button
                aria-haspopup="dialog"
                aria-label={i18n.t({
                    id: 'heartButtonAriaLabel',
                })}
                aria-pressed={toggled}
                {...buttonProps}
                className={`inline-flex items-center justify-center ${
                    toggled ? 's-text-link' : ''
                } ${externalClassname ?? ''}`}
                onClick={onClick}
                title={i18n.t({
                    id: 'heartButtonTitle',
                })}
                ref={forwardRef}
            >
                {toggled ? (
                    <IconFavorite16
                        stroke="var(--w-s-color-icon-primary)"
                        fill="var(--w-s-color-icon-primary)"
                    />
                ) : (
                    <IconFavorite16 {...iconProps} />
                )}
                {numFavs > 0 ? <span className="pl-4">{numFavs}</span> : null}
            </Button>
        );
    },
);

export default HeartButton;
